import { render, staticRenderFns } from "./jcu.vue?vue&type=template&id=73d6e9d8"
import script from "./jcu.vue?vue&type=script&lang=js"
export * from "./jcu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports